import { render, staticRenderFns } from "./ResumeCertifications.vue?vue&type=template&id=76585b07&"
import script from "./ResumeCertifications.vue?vue&type=script&lang=js&"
export * from "./ResumeCertifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports